import { takeEvery, call, put } from 'redux-saga/effects';
// redux-utils
import { merchTypes as types } from 'redux-utils/types/index';
import { actionTypeFormatter } from 'redux-utils/sagas/index';
// api helpers
import { deleteRequest, get, post, putRequest, endpoints } from 'api/index';

/**
 * @name appWatcherSaga
 * @description Watches for the action dispatched of certain type.
 */
const watcherSaga = [
  takeEvery(types.getFilters.request, getWorkerSaga),
  takeEvery(types.getPageComponents.request, getWorkerSaga),
  takeEvery(types.getCumulativeCards.request, getWorkerSaga),
  takeEvery(types.getMetricTabs.request, getWorkerSaga),
  takeEvery(types.getPerformanceTable.request, getWorkerSaga),
  takeEvery(types.downloadReport.request, getWorkerSaga),
  takeEvery(types.getScheduledReports.request, getWorkerSaga),
  takeEvery(types.getScheduledReportsMetaData.request, getWorkerSaga),
  takeEvery(types.postScheduledReport.request, getWorkerSaga),
  takeEvery(types.updateScheduledReport.request, getWorkerSaga),
  takeEvery(types.deleteScheduledReport.request, getWorkerSaga)
];

function getWorkerSaga(action) {
  switch (action.type) {
    case types.getFilters.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.filters,
        method: get,
        headers: ['auth']
      });
    }
    case types.getPageComponents.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.pageComponents,
        method: get,
        headers: ['auth']
        // useBaseURL: false
      });
    }
    case types.getCumulativeCards.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.cumulativeCards,
        method: get,
        headers: ['auth']
        // useBaseURL: false
      });
    }
    case types.getMetricTabs.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.getMetricTabs,
        method: get,
        headers: ['auth']
        // useBaseURL: false
      });
    }
    case types.getPerformanceTable.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.getPerformanceTable,
        method: get,
        headers: ['auth']
        // useBaseURL: false
      });
    }
    case types.downloadReport.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.downloadReport,
        method: get,
        headers: ['auth'],
        payload: action.payload
      });
    }
    case types.getScheduledReports.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.getScheduledReports,
        method: get,
        headers: ['auth']
        // useBaseURL: true
      });
    }
    case types.getScheduledReportsMetaData.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.getScheduledReportsMetaData,
        method: get,
        headers: ['auth']
        // useBaseURL: true
      });
    }
    case types.postScheduledReport.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.postScheduledReport,
        method: post,
        headers: ['auth'],
        payload: action.payload
        // useBaseURL: true,
      });
    }
    case types.updateScheduledReport.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.updateScheduledReport,
        method: putRequest,
        headers: ['auth'],
        payload: action.payload
        // useBaseURL: true,
      });
    }
    case types.deleteScheduledReport.request: {
      return apiWorkerSaga(action, {
        uriPath: endpoints.merchEvaluation.deleteScheduledReport,
        method: deleteRequest,
        headers: ['auth'],
        payload: action.payload
        // useBaseURL: true,
      });
    }
    default:
      return null;
  }
}

/**
 * @description Worker saga
 * @param {object} action - dispatched action
 * @param {object} params - api params
 * @returns {undefined}
 * @yields put - get success/error action.
 */
function* apiWorkerSaga(action, params) {
  try {
    const { response, error } = yield call(params.method, {
      payload: action.payload.params,
      useCachedInstance: false,
      ...params
    });
    if (response) {
      yield put({
        meta: action.meta,
        type: actionTypeFormatter(action.type, 'SUCCESS'),
        payload: {
          ...action.payload,
          error: null,
          response: response.data
        }
      });
    } else {
      yield put({
        meta: action.meta,
        type: actionTypeFormatter(action.type, 'FAILURE'),
        payload: {
          ...action.payload,
          error: error.data,
          response: null
        }
      });
    }
  } catch (error) {
    yield put({
      meta: action.meta,
      type: 'SAGA_ERROR',
      payload: {
        type: action.type,
        ...action.payload,
        error
      }
    });
  }
}

export default watcherSaga;
